/**
 * CareCaseStatusService
 * Service for managing care case statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for care case status CRUD operations
 */
export class CareCaseStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CareCaseStatusService.DEFAULT_SERVICE_PATH,
            basePath: CareCaseStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
CareCaseStatusService.DEFAULT_SERVICE_PATH = 'ac-counselling';
CareCaseStatusService.BASE_PATH = 'api/care-case-statuses';
//# sourceMappingURL=CareCaseStatusService.js.map